import React, { useState, useCallback, createContext } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import LawyerList from './LawyerList'
import LawyerDetailed from './LawyerDetailed'

const { lawyersData } = window
export const LawyersContext = createContext()

const Lawyers = () => {
	const [opened, setOpened] = useState(false)
	const [lawyerData, setLawyerData] = useState(null)
	const openDetailed = useCallback(ID => {
		setLawyerData(lawyersData[ID])
		setOpened(true)
	}, [])
	const closeDetailed = useCallback(() => {
		setOpened(false)
	}, [lawyerData])

	return (
		<LawyersContext.Provider
			value={{
				opened,
				openDetailed,
				closeDetailed,
				lawyerData
			}}
		>
			<LawyerList />
			<LawyerDetailed />
		</LawyersContext.Provider>
	)
}

const DomContent = document.getElementById('lawyer-wrapper')
if (DomContent) {
	ReactDOM.render(<Lawyers />, document.getElementById('lawyer-wrapper'))
}
